import * as Sentry from "@sentry/react";
import { getBuild } from "./utils";

// for local implementation add "LOCAL" to sentryAllowedEnvs and
// debug: true, in options object

const sentryAllowedEnvs = ["PROD", "PPTE", "DEV"];
const { REACT_APP_SENTRY_DSN, REACT_APP_VERSION } = process.env;

export default function sentryInit() {
  const { env } = getBuild();
  const shouldUseSentry = sentryAllowedEnvs.includes(env);
  if (shouldUseSentry) {
    Sentry.init({
      dsn: REACT_APP_SENTRY_DSN,
      environment: env,
      sampleRate: env === "PROD" ? 0.25 : 1.0,
      tracesSampleRate: env === "PROD" ? 0.25 : 1.0,
      release: REACT_APP_VERSION,
      integrations: [new Sentry.BrowserTracing()],
    });
  }
}
